import { onDocumentLoaded } from "../utils/on-document-loaded.js";
import Swiper from "swiper";
import { Pagination } from "swiper/modules";

onDocumentLoaded(() => {
    console.log("[business-types page loaded]");

    document.querySelectorAll(".prices__item").forEach((item) => {
        const btn = item.querySelector(".prices__item-more");

        if (!btn) return;

        btn.addEventListener("click", () => {
            item.classList.toggle("show");
        });
    });

    let pricesSwiper;

    function initPricesSwiper() {
        const ww = window.innerWidth;
        if (ww < 991) {
            if (!pricesSwiper) {
                pricesSwiper = new Swiper(".prices__items.swiper", {
                    wrapperClass: "prices__items-list",
                    slideClass: "prices__item",
                    slidesPerView: 1,
                    spaceBetween: 20,
                    modules: [Pagination],
                    pagination: {
                        el: ".prices__items-pagination",
                        clickable: true,
                    },
                    breakpoints: {
                        576: {
                            slidesPerView: 1.5,
                        },
                        768: {
                            slidesPerView: 2.2,
                        },
                    },
                });
            }
        } else {
            if (pricesSwiper) {
                pricesSwiper.destroy(true, true);
                pricesSwiper = null;
            }
        }
    }

    function initAccordion() {
        const accordions = document.querySelectorAll(
            ".table-functional__accordion",
        );
        if (!accordions) return;

        accordions.forEach((accordion) => {
            accordion
                .querySelector(".table-functional__accordion-item-header")
                .addEventListener("click", () => {
                    accordion.classList.toggle("show");
                });
        });
    }

    initPricesSwiper();
    initAccordion();

    window.addEventListener("resize", () => {
        initPricesSwiper();
    });
});
